import { create } from 'zustand';

import { CATEGORYPRODUCT } from '@/shared/interfaces/erp/inventario';
import { GetCategoryProductParams, getCategoryProducts } from '@/shared/actions/erp/inventario';

interface CategoriaProductoStore {
  categoriaProductos: CATEGORYPRODUCT[];
  categoriaNombre: string[]
  isLoadingCategoriaProducto: boolean;
  getCategoriaProducto: (params?: GetCategoryProductParams) => Promise<void>;
}

export const useCategoriaProductoStore = create<CategoriaProductoStore>(set => ({
  categoriaProductos: [],
  categoriaNombre: [],
  isLoadingCategoriaProducto: false,

  getCategoriaProducto: async params => {
    set({ isLoadingCategoriaProducto: true });
    const { data } = await getCategoryProducts(params);
    set({
      categoriaProductos: data.data,
      isLoadingCategoriaProducto: false,
      categoriaNombre: data.data.map(e => e.nombre)
    })
  },

}));
